import { render, staticRenderFns } from "./SeverityLevelBadge.vue?vue&type=template&id=5d25ad8c&scoped=true&"
import script from "./SeverityLevelBadge.vue?vue&type=script&lang=js&"
export * from "./SeverityLevelBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d25ad8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d25ad8c')) {
      api.createRecord('5d25ad8c', component.options)
    } else {
      api.reload('5d25ad8c', component.options)
    }
    module.hot.accept("./SeverityLevelBadge.vue?vue&type=template&id=5d25ad8c&scoped=true&", function () {
      api.rerender('5d25ad8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SeverityLevelBadge.vue"
export default component.exports